import React from "react";
import { ArrowUpRight } from "lucide-react";
import { registry } from "../mock";
import useReveal from "../hooks/useReveal";

export default function Registry() {
  const [ref, visible] = useReveal();
  return (
    <section className="px-6 py-20 md:py-28">
      <div
        ref={ref}
        className={`relative max-w-[1200px] mx-auto overflow-hidden rounded-sm reveal ${
          visible ? "is-visible" : ""
        }`}
      >
        <div className="img-zoom absolute inset-0">
          <img src={registry.image} alt="Gift registry" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-[#211E1A]/60" />
        <div className="relative z-10 text-center px-6 py-24 md:py-36 max-w-3xl mx-auto">
          <p className="text-[#F4EFE6] text-[12px] uppercase tracking-widest-2">{registry.kicker}</p>
          <h2 className="mt-6 font-serif-display text-[#F4EFE6] text-[34px] md:text-[52px] leading-tight">
            {registry.heading}
          </h2>
          <p className="mt-6 text-[#EAE1D2] leading-relaxed max-w-xl mx-auto">{registry.body}</p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={registry.registryUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-[#F4EFE6] text-[#211E1A] text-[12px] uppercase tracking-widest-2 px-7 py-[13px] rounded-sm hover:bg-[#9E2B25] hover:text-[#F4EFE6] transition-colors duration-300"
            >
              View Gift Registry <ArrowUpRight size={15} />
            </a>
            <a
              href={registry.honeymoonUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 border border-[#F4EFE6] text-[#F4EFE6] text-[12px] uppercase tracking-widest-2 px-7 py-[13px] rounded-sm hover:bg-[#F4EFE6] hover:text-[#211E1A] transition-colors duration-300"
            >
              Contribute to Honeymoon <ArrowUpRight size={15} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
